import { defineStore } from 'pinia';
import theme from '../theme';

// import { fetchTheme } from "@/services/themeService"; // for API

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: null
  }),
  actions: {
    async loadTheme() {
      // Static example:
      this.theme = theme;

      // Dynamic example:
    //   const res = await fetch("https://api.yourdomain.com/theme");
    //   this.theme = await res.json();
    },
    updateThemeSection(section, data) {
      if (this.theme && this.theme[section]) {
        this.theme[section] = { ...this.theme[section], ...data };
      }
    }
  }
});
